<template>
  <div class="flex w-full grow break-inside-avoid flex-col gap-1">
    <h3 class="text-title-medium grow">Textfeedbacks</h3>
    <div
      v-if="texts.length == 0"
      class="border-outline-variant rounded-small flex w-full items-center justify-center border p-4"
    >
      <span class="text-body-medium text-on-surface-variant">Keine Feedbacks</span>
    </div>
    <ul v-else class="flex w-full grow flex-col gap-1">
      <li
        v-for="text in texts"
        :key="text.question.id"
        class="rounded-small border-outline-variant flex w-full break-inside-avoid flex-col border p-2"
      >
        <h4 class="text-body-medium text-on-surface-variant mb-2">
          {{ text.question.content }}
        </h4>
        <TextFeedbacksForPerspectives :perspectives="text.perspectives" />
      </li>
    </ul>
  </div>
</template>

<script lang="ts" setup>
  import type { TextAnalysis } from '@/core/models/surveys-analytics'
  import TextFeedbacksForPerspectives from '@/core/components/analytics/text-feedback/TextFeedbacksForPerspectives.vue'

  interface Props {
    texts: ReadonlyArray<TextAnalysis>
  }

  defineProps<Props>()
</script>
